import React from "react";

export default function ReelVideo() {
  return (
    <svg
      style={{
        maxWidth: "15px"
      }}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.5102 0.833984H7.26697L7.45691 1.40379L8.93367 5.83398H12.1768L10.8758 1.93084L10.5102 0.833984ZM13.3135 7.50065C13.3264 7.50095 13.3393 7.50095 13.3523 7.50065H19.1663V14.584C19.1663 17.1153 17.1143 19.1673 14.583 19.1673H5.41634C2.88503 19.1673 0.833008 17.1153 0.833008 14.584V7.50065H8.31355C8.32641 7.50095 8.33934 7.50095 8.35226 7.50065H13.3135ZM13.9337 5.83398L12.4569 1.40379L12.267 0.833984H14.583C17.1143 0.833984 19.1663 2.88601 19.1663 5.41732V5.83398H13.9337ZM5.41634 0.833984H5.51015L5.87577 1.93084L7.17682 5.83398H0.833008V5.41732C0.833008 2.88601 2.88503 0.833984 5.41634 0.833984ZM8.39426 8.48465C8.13967 8.30644 7.80711 8.28468 7.5315 8.42815C7.25589 8.57165 7.08301 8.85657 7.08301 9.16732V15.0007C7.08301 15.3114 7.25589 15.5963 7.5315 15.7398C7.80711 15.8833 8.13967 15.8616 8.39426 15.6833L12.5609 12.7667C12.7837 12.6107 12.9163 12.3559 12.9163 12.084C12.9163 11.8121 12.7837 11.5572 12.5609 11.4013L8.39426 8.48465Z"
        fill="black"
      />
    </svg>
  );
}
